import { useEffect, useState } from "react";
import { Calendar, MessageSquare, Sparkles, Workflow } from "lucide-react";
import { api } from "@/lib/api";
import Layout from "@/components/Layout";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";

const FUTURE = [
  { icon: Calendar, name: "Calendar", desc: "Let MIA captures reference your schedule context." },
  { icon: Workflow, name: "Productivity systems", desc: "Route captured tasks into the tools you already use." },
  { icon: Sparkles, name: "External AI services", desc: "Connect other intelligence layers to your MIA memory." },
];

export default function Integrations() {
  const [integrations, setIntegrations] = useState([]);

  useEffect(() => {
    api.get("/v1/integrations").then(({ data }) => setIntegrations(data.integrations)).catch(() => {});
  }, []);

  const chatgpt = integrations.find((i) => i.provider === "chatgpt");

  return (
    <Layout>
      <div className="space-y-6" data-testid="integrations-page">
        <div>
          <h1 className="font-display text-3xl font-medium tracking-tight">Integrations</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Integrations let external intelligence read from your MIA memory — under your control.
          </p>
        </div>

        <div className="rounded-2xl border border-border bg-card p-6 sm:p-8" data-testid="chatgpt-integration-card">
          <div className="flex flex-wrap items-center gap-3">
            <MessageSquare className="h-6 w-6 text-muted-foreground" />
            <div>
              <p className="font-display text-lg font-medium">ChatGPT</p>
              <p className="text-sm text-muted-foreground">
                "What did I tell MIA today?" — ask ChatGPT about anything you captured.
              </p>
            </div>
            <Badge variant="outline" className="ml-auto" data-testid="chatgpt-status-badge">
              {chatgpt?.status === "coming_soon" ? "Coming Soon" : chatgpt?.status || "Coming Soon"}
            </Badge>
          </div>
          <div className="mt-6 flex flex-wrap items-center gap-4">
            <Button disabled data-testid="connect-chatgpt-button">Connect ChatGPT</Button>
            <p className="text-xs leading-relaxed text-muted-foreground">
              MIA will connect through official OpenAI integration mechanisms.
              <br />
              We never ask for — or store — your ChatGPT password.
            </p>
          </div>
        </div>

        <div>
          <h2 className="font-mono text-xs uppercase tracking-[0.25em] text-muted-foreground">On the roadmap</h2>
          <ul className="mt-4 grid gap-4 sm:grid-cols-3" data-testid="future-integrations-list">
            {FUTURE.map((f) => (
              <li key={f.name} className="rounded-2xl border border-dashed border-border p-5" data-testid={`future-integration-${f.name.toLowerCase().replace(/\s+/g, "-")}`}>
                <f.icon className="h-5 w-5 text-muted-foreground" />
                <p className="mt-3 text-sm font-medium">{f.name}</p>
                <p className="mt-1 text-xs leading-relaxed text-muted-foreground">{f.desc}</p>
                <Badge variant="outline" className="mt-3">Coming Soon</Badge>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Layout>
  );
}
